export default __webpack_public_path__ + "static/media/tianas2.1b41ee94.jpg";